import React from "react";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../../../assets/logo-avellaneda.png";
import NunitoBold from "../../../fonts/Nunito-Bold.ttf";
import Nunito from "../../../fonts/Nunito-Regular.ttf";

// Register font
Font.register({
  family: "NunitoBold",
  src: NunitoBold,
});
Font.register({
  family: "Nunito",
  src: Nunito,
});

const colorPrincipal = "#83C442";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    fontFamily: "Nunito",
    fontWeight: "bold",
    fontSize: "12pt",
  },
  sectionHeader: {
    margin: 10,
    padding: 5,
    flexGrow: 1,
  },
  titulo: {
    fontFamily: "NunitoBold",
    fontSize: "20pt",
    marginTop: 5,
  },
  subTitulo: {
    marginTop: 5,
    marginBottom: 10,
    fontSize: "15pt",
  },
  subTituloDatos: {
    fontSize: "18pt",
    backgroundColor: colorPrincipal,
    fontFamily: "NunitoBold",
    color: "white",
    paddingTop: "5",
    paddingLeft: "10",
    paddingBottom: "5",
    marginTop: 15,
  },
  colorFecha: {
    color: "#646464",
  },
  negrita: {
    fontFamily: "NunitoBold",
  },
  campoFecha: {
    fontFamily: "NunitoBold",
    fontSize: "18pt",
    borderBottom: 0,
    borderLeft: 1,
    borderRight: 1,
    borderColor: "#ddd",
    padding: 15,
    backgroundColor: "#eee",
  },
  recordatorio: {
    fontSize: "20pt",
    borderTopColor: "#b1b1b1",
    borderBottomColor: "#ddd",
    borderLeftColor: "#ddd",
    borderRightColor: "#ddd",
    borderWidth: 1,
    padding: 15,
    backgroundColor: "#eee",
  },
  franjaLogo: {
    backgroundColor: colorPrincipal,
    width: "100vw",
    paddingTop: 8,
    paddingBottom: 8,
  },
  image: {
    height: "20pt",
    width: "100pt",
    margin: "auto",
  },
  boxData: {
    borderLeft: 1,
    borderBottom: 1,
    borderRight: 1,
    borderColor: "#ddd",
    paddingTop: "5",
    paddingLeft: "10",
    paddingBottom: "5",
    //padding: 15,
  },
  marginTopLeyenda: {
    marginTop: 20,
  },
  centerText: {
    textAlign: "left",
  },
  marginTopNormal: {
    marginTop: 10,
  },
  textoGrande: {
    fontSize: "14pt",
  },
  subRayado: {
    textDecoration: "underline",
  },
});

function MyDoc({ data }) {
  const { nombre, dni, lugar, servicio, nroTurno, fecha, hora, padron, tipoPadron, leyenda, conSuscriptor, email, telFijo, telMovil } = data;

  console.log(data);

  const esNegrita = (palabra) => palabra.includes("[");

  const eliminarBrackets = (palabra) => {
    const regex = /(\[)|(\])/g;
    const str = palabra.replace(regex, "");
    return str;
  };

  const agregarEspacio = (texto) => ` ${texto} `;
  const guion = () => "-";

  const wrapperText = (str) => {
    const texto = str.trim();
    const palabras = texto.split(" ");
    return palabras.map((palabra, index) => {
      if (esNegrita(palabra)) {
        return (
          <Text key={index} style={[styles.negrita]}>
            {agregarEspacio(eliminarBrackets(palabra))}
          </Text>
        );
      } else {
        return <Text key={index}>{agregarEspacio(palabra)}</Text>;
      }
    });
  };

  function parserFormatoImpresion(estructura) {
    if (!estructura) {
      return false;
    }
    estructura = JSON.parse(estructura);
    const itemsListado = estructura.items.map((item) => (
      <Text>
        {guion()} {wrapperText(item)}
      </Text>
    ));
    return (
      <>
        <View>
          <Text
            style={[
              styles.subTitulo,
              styles.marginTopLeyenda,
              styles.subRayado,
              styles.negrita,
            ]}
          >
            {estructura.titulo}
          </Text>
          <View>{itemsListado}</View>
        </View>
      </>
    );
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View>
          <View style={[styles.franjaLogo]}>
            <Image src={logo} style={styles.image} />
          </View>
          <View style={styles.sectionHeader}>
            <View>
              <View>
                <Text style={styles.titulo}>
                  Comprobante de Asignación de Turno
                </Text>
                <Text style={styles.subTitulo}>
                  Municipalidad de Avellaneda
                </Text>
              </View>
            </View>
            <View style={[styles.centerText]}>
              <Text>
                <Text style={[styles.negrita, styles.textoGrande]}>Lugar:</Text> {` ${lugar}`}
              </Text>
              <Text>
                <Text style={[styles.negrita, styles.textoGrande]}>Servicio:</Text> {` ${servicio}`}
              </Text>
            </View>
            <View style={[styles.marginTopNormal, styles.centerText]}>
              <Text style={[styles.textoGrande]}>
                <Text style={[styles.negrita]}>Nro. Turno:</Text>{" "}
                {` ${nroTurno}`}
              </Text>
              <Text style={[styles.textoGrande]}>
                <Text style={styles.negrita}>Fecha:</Text> {` ${fecha}  `}
                <Text style={styles.negrita}>Hora:</Text> {` ${hora}`}
              </Text>
              <Text style={[styles.textoGrande]}>
                <Text style={styles.negrita}>Padrón:</Text> {` ${padron}  `}
                <Text style={styles.negrita}>Tipo Padrón:</Text> {` ${tipoPadron}`}
              </Text>
            </View>
            <View style={[styles.centerText, styles.marginTopNormal]}>
              <Text>
                <Text style={[styles.negrita, styles.textoGrande]}>Solicitante:</Text>
                {` ${nombre}`}
              </Text>
              <Text>
                <Text style={[styles.negrita, styles.textoGrande]}>DNI:</Text> {` ${dni}   `}
              </Text>
              <Text>
                <Text style={[styles.negrita, styles.textoGrande]}>Email:</Text> {` ${email}   `}
              </Text>
              <Text>
                <Text style={[styles.negrita, styles.textoGrande]}>Tel. Fijo:</Text> {` ${telFijo}   `}
              </Text>
              {
                Boolean(telMovil) && 
              <Text>
                <Text style={[styles.negrita, styles.textoGrande]}>Tel. Móvil:</Text> {` ${telMovil}   `}
              </Text>
              }
              <Text>
                <Text style={[styles.negrita, styles.textoGrande]}>Condición del suscriptor:</Text> {` ${conSuscriptor}   `}
              </Text>
            </View>

            <View>
              <Text style={[styles.negrita, styles.marginTopLeyenda, styles.textoGrande]}>{leyenda}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

function TurnoPdf({ nombreArchivo, data }) {
  return (
    <div>
      <PDFDownloadLink
        document={<MyDoc data={data} />}
        fileName={nombreArchivo}
      >
        {({ blob, url, loading, error }) =>
          loading ? "Cargando..." : "Descargar comprobante"
        }
      </PDFDownloadLink>
    </div>
  );
}

export default TurnoPdf;
